

















import { Component, Prop, Vue } from "vue-property-decorator";
import validate from "@/directives/validateDirect";

@Component({
    directives: {
        validate
    }
})
export default class vscInput extends Vue {
    @Prop() private value!: string;
    @Prop() label!: string;
    @Prop() placeholder!: any;
    @Prop({ default: "lg" }) size!: string;
    @Prop() suffix!: string;
    @Prop() validator!: any;
    @Prop({ default: false }) inline!: boolean;
    @Prop({ default: true }) showValidationMessage!: boolean;
    @Prop({ default: true }) margin!: boolean;
    @Prop({ default: "text" }) type!: string;

    get inputValue() {
        return this.value;
    }

    set inputValue(input) {
        this.$emit("input", input);
    }

    get rowClasses() {
        if (!this.inline) return `form-group row ${this.margin ? "" : "mb-0"}`;
        return "w-100";
    }

    get colSize() {
        if (this.size === "xl") return "";
        return "col-lg-8";
    }
}
